import { getLocale } from 'i18n';
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import styles from './DocumentView.module.scss'
import { themeColor } from 'theme/colors'

const ACTION_ICONS = {
  created:   '📝',
  signed:    '✅',
  returned:  '↩️',
  approved:  '🎉',
  sent_acq:  '📤',
  cancelled: '🚫',
}

const ACTION_COLORS = {
  created:   '#1d4ed8',
  signed:    '#15803d',
  returned:  '#b91c1c',
  approved:  '#059669',
  sent_acq:  '#7c3aed',
  cancelled: '#6b7280',
}

function fmtDate(str) {
  if (!str) return ''
  const d = new Date(str)
  if (isNaN(d.getTime())) return str
  return d.toLocaleString(getLocale(), {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

export default function DocHistory({ activities = [] }) {
  useInterfaceLanguage();
  if (!activities.length) {
    return (
      <div className={styles.historySection}>
        <h3 className={styles.panelSectionTitle}>{tr("История документа")}</h3>
        <p className={styles.emptySub}>{tr("История событий пуста")}</p>
      </div>
    )
  }

  return (
    <div className={styles.historySection}>
      <h3 className={styles.panelSectionTitle}>{tr("История документа")}<span className={styles.commentCount}>{tr(activities.length)}</span>
      </h3>

      <div className={styles.timeline}>
        {activities.map((a, i) => {
          const rawColor = ACTION_COLORS[a.action] || '#64748b'
          const color = themeColor(rawColor)
          return (
            <div key={a.id} className={styles.timelineItem}>
              <div className={styles.timelineLeft}>
                <div
                  className={styles.timelineIcon}
                  style={{ color, borderColor: themeColor(rawColor + '33', 'border'), background: themeColor(rawColor + '10', 'background') }}
                >
                  {tr(ACTION_ICONS[a.action] || '•')}
                </div>
                {tr(i < activities.length - 1 && <div className={styles.timelineLine} />)}
              </div>

              <div className={styles.timelineContent}>
                <span className={styles.timelineAction} style={{ color }}>
                  {tr(a.action_display)}
                </span>
                {tr(a.employee_name && (
                  <span className={styles.timelineEmployee}>
                    {tr(a.employee_name)}
                    {tr(a.employee_dept && (
                      <span className={styles.timelineDept}> · {tr(a.employee_dept)}</span>
                    ))}
                  </span>
                ))}
                {tr(a.note && <span className={styles.timelineNote}>{tr(a.note)}</span>)}
                <span className={styles.timelineDate}>{fmtDate(a.created_at)}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
